module.exports = __webpack_public_path__ + "static/img/partner-ws.83d293c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/productService/partner/partner-ws.png
// module id = DPc+
// module chunks = 34